import { hasProperty } from '@helpers/objectHelpers';
import { ColumnsListItem, MegaMenuColumn } from '../MegaMenu.types';

const filterColumnList = (el: ColumnsListItem, level: number) => {
  const column = [];

  switch (level) {
    case 4: {
      if ('Children' in el && el.Children?.length > 0 && hasProperty(el, 'NoSubCategory')) {
        column.push(el.Children);
      } else {
        column.push([]);
      }
      break;
    }
    default: {
      if (el.NoSubCategory) {
        column.push([el] as MegaMenuColumn[]);
      } else if ('ColumnAndSection' in el && el.ColumnAndSection?.length > 0) {
        column.push(el.ColumnAndSection);
      } else if ('Sections' in el && el.Sections?.length > 0) {
        column.push(el.Sections);
      } else if ('Children' in el && el.Children?.length > 0) {
        column.push(el.Children);
      } else {
        column.push([]);
      }
    }
  }
  return column;
};

export const renderOtherColumn = (
  columnData: ColumnsListItem[] | ColumnsListItem[][],
  level: number
) => {
  const column: ColumnsListItem[] | ColumnsListItem[][] = [];
  if (columnData) {
    columnData.forEach((el) => {
      if (level === 2) {
        const data = filterColumnList(el, level);
        column.push(...data);
      } else if (Array.isArray(el)) {
        el.forEach((element) => {
          const data = filterColumnList(element, level);
          column.push(...data);
        });
      }
    });
  }
  return column;
};
